import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import { IApiResult, ICoinUnitPrice } from '../types';
import api from './base';

export enum CoinUnitPriceType {
  InProgress = 'inProgress',
  ToBeFinalized = 'toBeFinalized',
  Finalized = 'finalized',
  Recent = 'recent',
}

export function fetchCoinUnitPrices(type: CoinUnitPriceType, year?: number): [Promise<AxiosResponse<ICoinUnitPrice[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/coin-unit-prices`;

  return api.getWithCancel(uri, {
    params: {
      type,
      year,
    },
  });
}

export function downloadCoinUnitPrices(type: CoinUnitPriceType, year?: number): Promise<AxiosResponse<any>> {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/download-coin-unit-prices`;

  return api.http.get(uri, {
    params: {
      type,
      year,
    },
  });
}

export function updateCoinUnitPrices(price: ICoinUnitPrice): Promise<AxiosResponse<IApiResult<ICoinUnitPrice>>> {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/coin-unit-prices/${price.id}`;

  return api.http.put(uri, price);
}
